/**
 * Configure the targets to respective lead source and month. here we can add, edit, activate actions.
 * Based on the configurations lead soruce wise revenue report is generated to respective month.
 * without leadsource configuration report wont generate. 
 * To get accurate reports, configure respective lead source staring of every month one day before.
 */
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { GetRoles } from 'src/app/actions/roleManagement.action';
import { ReportsService } from '../../services/reports.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { MessageServiceService } from '../../services/message-service.service'
import { CommonMethods } from '../../shared/CommonMethods';
import { Constants } from './../../app.constants';
import { UserprivilegeService } from './../../services/userprivilege.service';
import { ExportOptions } from 'src/app/models/common-model';
import { CommonService } from 'src/app/services/common.service';
import { PostSetTargets, PostSetTargetsToLeadSource, SetTargets, SetTargetsToLeadSources } from 'src/app/models/reports.model';
@Component({
  selector: 'app-set-targets-to-lead-sources',
  templateUrl: './set-targets-to-lead-sources.component.html',
  styleUrls: ['./set-targets-to-lead-sources.component.scss']
})
export class SetTargetsToLeadSourcesComponent implements OnInit {

  isSubmitted = false
  confirmModalRef: BsModalRef;
  @ViewChild('confirmTemplate', { static: false }) confirmTemplate: TemplateRef<any>;
  config = {
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  }
  columns: any[];
  activeOptions: any[];
  isUpdateFlag: Boolean = false;
  targetsData: SetTargetsToLeadSources[] = [];
  addForm: FormGroup;
  dateConfig: Partial<BsDatepickerConfig>;
  targetMinDate: Date
  targetMaxDate: Date
  postTargetData: PostSetTargetsToLeadSource;
  filterBrandWiseId: any = "";

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private modalService: BsModalService,
    private messageService: MessageServiceService,
    private userPrivilegesService: UserprivilegeService,
    private reportsSerive: ReportsService,
    private commonService: CommonService,
  ) {

    this.dateConfig = Object.assign({}, { containerClass: 'theme-orange', dateInputFormat: 'MM/YYYY' });
    this.columns = [
      { field: 'businessUnitName', header: 'Brand Name', width: '15%' },
      { field: 'leadSourceName', header: 'Lead Source', width: '15%' },
      { field: 'selectedMonth', header: 'Month', width: '15%' },
      { field: 'targetLeads', header: 'Targeted Leads', width: '15%' },
      { field: 'spentAmount', header: 'Spent Amount', width: '15%' },
      { field: 'monthlyBudget', header: 'Monthly Budget', width: '15%' },
      { field: 'createdOn', header: 'Created On', width: '15%' },
      { field: 'isActive', header: 'Target Status', width: '15%' },
    ];

    this.activeOptions = [
      { label: 'All', value: null },
      { label: 'Activated', value: '1' },
      { label: 'Deactivated', value: '0' }
    ];
  }
  //Privilege flags
  hasAddEditPrivilege: Boolean = false;
  hasActivateDeactivatePrivilege: Boolean = false;
  hasExportPrivilege: Boolean = false;
  ngOnInit() {
    this.getBussinessUnits();
    this.getAllLeadSources();
    this.createForm();

    setTimeout(() => {

      if (this.userPrivilegesService.hasAddEditPrivilege(Constants.ManageRoleScreen)) {
        this.hasAddEditPrivilege = true;
      }
      if (this.userPrivilegesService.hasActivateDeActivatePrivilege(Constants.ManageRoleScreen)) {
        this.hasActivateDeactivatePrivilege = true;
      }
      if (this.userPrivilegesService.hasExportPrivilege(Constants.ManageRoleScreen)) {
        this.hasExportPrivilege = true;
      }

    }, 500);
  }

  createForm() {
    this.addForm = this.fb.group({
      businessUnitName: ["", [Validators.required]],
      // leadSource: ['',[Validators.required]],
      targetLeads: ['', [Validators.required]],
      spentAmount: ['', [Validators.required]],
      monthlyBudget: ['', [Validators.required]],
      selectedMonth: ['', [Validators.required]],
    })
  }

  brandWiseData: any[] = [];
  getBussinessUnits() {
    this.commonService.getAllBussinessUnits()
      .subscribe((res: any) => {
        if (res && res.response && res.response.length > 0) {
          for (const iterator of res.response) {
            if (iterator['tataDialerType'] != "") {
              this.brandWiseData = res.response;
            }
          }
        }
        else {
          this.brandWiseData = [];
        }
        this.getAllTargetsList();
      }, error => {
        console.log(error)
      })
  }


  totalRecords: number = 0;
  tempTargetsData: SetTargetsToLeadSources[];
  getAllTargetsList() {
    this.isSubmitted = true
    this.reportsSerive.getAllTargetedToLeadSourceList()
      .subscribe((res: any) => {
        if (res.response.length > 0) {
          this.targetsData = res.response;
          this.tempTargetsData = res.response;
        }
        this.isSubmitted = false
      }, error => {
        this.isSubmitted = false
        this.messageService.showErrorMessage("Unable to retrieve lead source targets data from server ");
      })
  }


  modalTitle: string = "Add Target";
  currentSelectedTarget: SetTargetsToLeadSources = <SetTargetsToLeadSources>{};
  editTarget(payload) {
    this.currentSelectedTarget = <SetTargetsToLeadSources>{};
    this.currentSelectedTarget = payload;
    this.modalTitle = "Update Target";
    this.confirmModalRef = this.modalService.show(this.confirmTemplate, Object.assign({}, this.config, { class: 'gray modal-md modal-dialog-centered' }));
    this.isUpdateFlag = true;

    this.selectedbussinessUnit = this.bussinessUnitsData.filter(obj => {
      return obj.autoId === this.currentSelectedTarget.leadSourceId
    })
    this.addForm.get('selectedMonth').setValue(this.changeDateFormat(this.currentSelectedTarget.selectedMonth));
    this.addForm.get('targetLeads').setValue(this.currentSelectedTarget.targetLeads);
    this.addForm.get('spentAmount').setValue(this.currentSelectedTarget.spentAmount);
    this.addForm.get('monthlyBudget').setValue(this.currentSelectedTarget.monthlyBudget);
    this.filterBrandWiseId = this.currentSelectedTarget.businessUnitName;
  }

  changeDateFormat(d) {
    let a = d.split(' '); //a[1] = time
    let aa = a[0].split('-');
    return new Date(aa[2] + "/" + aa[1] + "/" + aa[0] + " " + a[1]);
  }

  addRoleModal() {
    this.modalTitle = "Add Target";
    this.confirmModalRef = this.modalService.show(this.confirmTemplate, Object.assign({}, this.config, { class: 'gray modal-md modal-dialog-centered' }));
    this.isUpdateFlag = false;
    this.currentSelectedTarget = <SetTargetsToLeadSources>{};
    this.clearForm();
  }

  clearForm() {
    if (this.isUpdateFlag) {
      this.selectedbussinessUnit = this.bussinessUnitsData.filter(obj => {
        return obj.autoId === this.currentSelectedTarget.leadSourceId
      })
      this.addForm.get('selectedMonth').setValue(this.changeDateFormat(this.currentSelectedTarget.selectedMonth));
      this.addForm.get('targetLeads').setValue(this.currentSelectedTarget.targetLeads);
      this.addForm.get('spentAmount').setValue(this.currentSelectedTarget.spentAmount);
      this.addForm.get('monthlyBudget').setValue(this.currentSelectedTarget.monthlyBudget);
      this.filterBrandWiseId = this.currentSelectedTarget.businessUnitName;
    }
    else {
      this.addForm.reset();
      this.filterBrandWiseId = "";
      this.selectedbussinessUnit = [];
      this.isUpdateFlag = false;
    }
  }

  selectedbussinessUnit = [];
  onSubmit(formData) {
    if (this.selectedbussinessUnit.length == 0) {
      this.messageService.showErrorMessage("Lead Source is Required");
      this.isSubmitted = false;
      return;
    }
    this.isSubmitted = true
    const controls = this.addForm.controls;
    /** check form */
    if (this.addForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      this.isSubmitted = false;
      return;
    }

    this.postTargetData = {
      businessUnitName: formData.businessUnitName,
      leadSourceId: this.selectedbussinessUnit[0].autoId,
      targetLeads: +formData.targetLeads,
      spentAmount: +formData.spentAmount,
      monthlyBudget: +formData.monthlyBudget,
      SelectedMonth: new Date(formData.selectedMonth),
      operation: this.isUpdateFlag ? "Edit" : "Add",
      targetId: this.isUpdateFlag ? this.currentSelectedTarget.targetId : 0,
      isActive: 1
    }
    this.reportsSerive.setRevenueTargetToLeadSourceData(this.postTargetData)
      .subscribe(res => {
        debugger;
        
        this.isSubmitted = false
        if (res.isSuccess) {
          if (res.response.statusCode == 4) {
            this.messageService.showSuccess("Target " + (this.isUpdateFlag ? "Updated" : "Added") + " Successfully");
            this.clearForm()
            this.closeConfirmModal();
          } else if (res.response.statusCode == -1) {
            this.messageService.showSuccess("Target already exist with this combination");
          }
        } else {
          this.messageService.showSuccess(res.response.statusMessage);
        }
        this.getAllTargetsList();
      }, error => {
        this.isSubmitted = false
        this.messageService.showErrorMessage("Unable to update leadsoruce target , An error occur while updating leadsoruce target.");
      })
  }


  updateActivationForTarget(data) {
    if (data) {
      this.postTargetData = {
        businessUnitName: "",
        leadSourceId: 12,
        targetLeads: 12,
        spentAmount: 12,
        monthlyBudget: 12,
        SelectedMonth: new Date(),
        operation: "ActivateDeactivate",
        targetId: this.currentSelectedTarget.targetId,
        isActive: this.currentSelectedTarget.isActive
      }

      this.reportsSerive.setRevenueTargetToLeadSourceData(this.postTargetData)
        .subscribe(res => {
          this.isSubmitted = false
          if (res.isSuccess) {
            if (res.response.statusCode == 4) {
              this.messageService.showSuccess("Target Updated Successfully");
              this.clearForm()
            } else if (res.response.statusCode == -1) {
              this.messageService.showSuccess("Target already exist with this combination");
            }

          } else {
            this.messageService.showSuccess(res.response.statusMessage);
          }

          this.getAllTargetsList();
        }, error => {
          this.isSubmitted = false
          this.messageService.showErrorMessage("Unable to update leadsoruce target , An error occur while updating leadsoruce target.");
        })
    } else {
      this.currentSelectedTarget.isActive = this.currentSelectedTarget["isActive"] == 1 ? 0 : 1;
    }
  }

  askConfirmation(data, opType) {
    data.isActive = data.isActive == 0 ? 1 : 0;
    this.currentSelectedTarget = data;
    let confirmMessage = data.isActive ? "activate" : "deactivate";
    this.messageService.confirmationMessage("you want to " + confirmMessage + " it");
  }


  closeConfirmModal() {
    this.confirmModalRef.hide();
  }

  bussinessUnitsData: any[] = [];
  DropDownBussinessUnits: any[] = [];
  getAllLeadSources() {
    this.commonService.getAllLeadSources()
      .subscribe((res: any) => {
        if (res.response.length > 0) {
          this.bussinessUnitsData = res.response;
          let sourceObj = [];
          sourceObj.push({ label: 'All', value: "" })
          res.response.forEach(function (item) {
            sourceObj.push({ label: item.name, value: item.name })
          });
          this.DropDownBussinessUnits = sourceObj;
        }
        else {
          this.bussinessUnitsData = [];
          this.DropDownBussinessUnits = [];
        }
      }, error => {
        this.messageService.showErrorMessage("Unable to retrieve leadsource data from server ");
      })
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.addForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  filterLeadSource = ""
  filterActive = ""
  filterSelectedDate = "";
  resetDataTablefilter(dt) {
    this.filterLeadSource = ""
    this.filterActive = ""
    this.filterSelectedDate = "";
    dt.reset();
    this.getAllTargetsList();
  }

  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('month');
  }
  replaceDateFormat(createdOn: string) {
    return createdOn.replace('T', " ");
  }

  dateFilterOnData(data) {
    debugger;
    if (data && new Date(data).getFullYear() != 1970) {
      let tempMon = new Date(data).getMonth() + 1 + "";
      let selectedM = (tempMon.length == 1 ? "0" + tempMon : tempMon) + "-" + new Date(data).getFullYear();
      let filterData = [];
      this.tempTargetsData.forEach(function (item) {
        let tempSelectedM = (item.selectedMonth).toString().substr(3, 7);
        if (tempSelectedM == selectedM) {
          filterData.push(item);
        }
      });
      this.targetsData = filterData;
    }
    else
    {
      this.targetsData = this.tempTargetsData;
    }
  }
}
